<div class="tableContainer table-mobile table-mobile-gridview">
  <div class="tableTopSec">

    <div class="row">
      <div class="col-md-4">
      </div>
      <div class="col-xl-8 col-lg-8 col-md-8 text-right">
        <mat-paginator #placedOrdersPaginator [length]="length"
                       *ngIf="isPaginatorRequired"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       (page)="onPaginatorChange($event)">
        </mat-paginator>
        <button *ngIf="!isReadOnlyAccess && isCreateButton" mat-raised-button class="btns margin-l5 index-z200 d-none d-md-inline-block" (click)="onCretePerformed($event)" color="primary">{{CreateButtonTitle}}</button>
      </div>
    </div>
  </div>
  <div class="tableComponentOuter" (window:resize)="onresize($event)">
    <table class="matTables tableComponentInner mat-table acountTable" matSort (matSortChange)="sortData($event)">
      <thead>
        <tr class="mat-header-cell">
          <th [class]="header?.className" *ngFor="let header of headerDS" [mat-sort-header]="header?.columnfield" [disabled]="header?.columnfield ==  'contextMenu' || 'contextMenuIcon'? true : false">
            <div>
              {{header.headertxt}}
            </div>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="paginatorDS.length != 0">
        <tr class="mat-row" *ngFor="let row of paginatorDS">
          <td class="mat-cell" *ngFor="let col of headerDS">
            <div class="d-block d-sm-none d-md-none xs-label"> {{col.headertxt}}</div>
            <div *ngIf="col && row[col.columnfield + 'InnerHtml'] == null && col.columnfield!='contextMenu'  && !col.cellAction  && !col.isAddress">
              {{col.dataType==cellDataType.Date ? (row[col?.columnfield] | date:col?.textFormat): (col.dataType==cellDataType.Integer ? (row[col?.columnfield] | number:col.textFormat):row[col?.columnfield]) }}
            </div>
            <div *ngIf="col && row[col.columnfield + 'InnerHtml'] == null && col.columnfield!='contextMenu' && col.cellAction  && !col.isAddress">
              <a (click)="onUpdatePerformed($event,row)"> {{col.dataType==cellDataType.Date ? (row[col?.columnfield] | date:col?.textFormat): (col.dataType==cellDataType.Integer ? (row[col?.columnfield] | number:col.textFormat):row[col?.columnfield]) }}</a>
            </div>
            <div *ngIf="col && row[col.columnfield + 'InnerHtml'] == null && col.columnfield!='contextMenu'  && !col.cellAction && col.isAddress">
              <div class="order-info ml-0 defaultCursor">
                <p class="grower-name">
                  {{row[col?.CombineCol[0]]}}
                </p>
                <p>{{row[col?.CombineCol[1]] || row[col?.CombineCol[2]]}}, {{row[col?.CombineCol[3]]}}, {{row[col?.CombineCol[4]]}} {{row[col?.CombineCol[5]]}}</p>
              </div>
            </div>

            <div *ngIf="col && row[col.columnfield + 'InnerHtml'] == null && col.columnfield!='contextMenu' && !col.cellAction  && !col.isAddress && col.IsSingleAction">
              <i title={{col?.IconTitle}} class={{col?.OverideClass}} (click)="onActionPerformed($event,row,col.IconTitle)"></i>
            </div>

            <div *ngIf="col && row[col.columnfield + 'InnerHtml'] == null && col.columnfield=='contextMenu' && !col.cellAction && !col.isAddress">
              <div *ngFor="let action of row.Action">
                <div *ngIf="action =='Cancel Request'">
                  <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                    <i class="fas fa-ellipsis-v"></i>
                  </button>
                  <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                    <span *ngFor="let action of row.Action">
                      <button mat-menu-item (click)="onActionPerformed($event,row,action)">{{action}}</button>
                    </span>
                  </mat-menu>
                </div>
              </div>
            </div>
            <div *ngIf="col && row[col.columnfield + 'InnerHtml'] !=null" innerHTML="{{row[col.columnfield + 'InnerHtml']}}"></div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="paginatorDS.length == 0">
        <tr>
          <td class="mat-cell noRecordMsg" colspan="8">
            No record Found.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
